<template>
    <div class="grow">
        <!-- Recently added (Favorites). -->
        <PinsRecentlyAdded
            v-if="drawer.pins.length || searchIsLoading"
            :search-input="modelValue"
            :sort-value="sortValue"
            :is-view-all="isViewAll"
            @toggle:view-all="isViewAll = !isViewAll"
        />
        <!-- When there are no pins to show. -->
        <PinsEmptyState v-else />
        <!-- Trays. -->
        <PinsTrays :search-input="modelValue" :inert="inert" v-if="!isViewAll" />
    </div>
</template>

<script setup>
import {PinsEmptyState, PinsRecentlyAdded, PinsTrays} from "@/Components/Modules/Dialogs/Pins/Components";
import {usePinsDrawer} from "@/Composables";
import {ref} from "vue";

const props = defineProps(['modelValue','sortValue', 'inert']);

const isViewAll = ref(false);
const { drawer, searchIsLoading } = usePinsDrawer();
</script>
